import store from '../store';

// Moeda da loja e idioma do cliente (INTERNACIONALIZACAO_EUA_PLAN.md §4.3).
//
// Real em português é o formato de sempre, montado à mão ("R$" + espaço + formatPrice), e não pelo
// Intl: o Intl põe um espaço inseparável depois do "R$", o que mudaria o texto das lojas brasileiras.

const LOCALES = { 'pt-BR': 'pt-BR', en: 'en-US' };

export const idiomaAtual = () => store.state.idioma || store.state.configuracoes?.idioma_cardapio || 'pt-BR';

export const moedaAtual = () => store.state.configuracoes?.moeda || 'BRL';

export const formatoLegado = () => moedaAtual() === 'BRL' && idiomaAtual() === 'pt-BR';

const formatador = casas => new Intl.NumberFormat(LOCALES[idiomaAtual()] || 'pt-BR', {
    style: 'currency',
    currency: moedaAtual(),
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
});

export const formatarMoeda = (valor, casas = 2) => formatador(casas).format(+valor || 0);

export const simboloMoeda = () => {
    if (formatoLegado()) {
        return 'R$';
    }

    const parte = formatador(2).formatToParts(0).find(p => p.type === 'currency');
    return parte ? parte.value : moedaAtual();
};
